// must use relative path because of unit test
import { produceCheckOptions, produceSelectOptions } from '../../../../utils/filter'
import { getGlobalParams } from '../../../../config/config'

const { countryConfig } = getGlobalParams()
const { assetClassOrder, investmentRegionOrder, dividendTypeOrder, fundRatingOrder, msRatingOrder, currencyOrder } =
  countryConfig.categoriesOrders

const filterRules = {
  extraClasses: '',
  common: {
    terms: {
      expand: '#{fundList.filter.expand}',
      shrink: '#{fundList.filter.shrink}',
      placeholderSelected: '#{fundList.filter.placeholderSelected}',
      placeholderUnselected: '#{fundList.filter.placeholderUnselected}'
    }
  },
  blocks: [
    {
      extraClasses: 'align-middle',
      elements: [
        {
          extraClasses: 'large-6 xlarge-5',
          type: 'input',
          label: '#{fundList.filter.search.label}',
          placeholder: '#{fundList.filter.search.placeholder}',
          // eslint-disable-next-line prettier/prettier
          key: 'shareClassName.zh||shareClassName.en||isin||taCode',
          wholeMatchKeys: ['taCode'],
          value: '',
          splittingWords: [],
          dividingWord: '#!'
        }
      ]
    },
    {
      extraClasses: 'show-for-large',
      elements: [
        {
          extraClasses: 'large-6',
          type: 'check',
          label: '#{fundList.filter.fundType}',
          key: 'fundRangeCode.longName',
          id: 'fundRangeCode',
          options: (fundItems) => produceCheckOptions(fundItems, 'fundRangeCode.longName', ['境內基金', '境外基金'], 'show-for-large'),
          value: []
        }
      ]
    },
    {
      extraClasses: 'hide-for-large',
      elements: [
        {
          extraClasses: 'large-6',
          type: 'check',
          label: '#{fundList.filter.fundType}',
          key: 'fundRangeCode.shortName',
          id: 'fundRangeCodeShort',
          options: (fundItems) => produceCheckOptions(fundItems, 'fundRangeCode.shortName', ['境內', '境外'], 'hide-for-large'),
          value: []
        }
      ]
    },
    {
      extraClasses: '',
      elements: [
        {
          id: 'assetClass', // ids are for testing purpose
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.investmentType}',
          key: 'assetClass.name',
          options: (fundItems) => produceSelectOptions(fundItems, 'assetClass.name', assetClassOrder),
          value: []
        },
        {
          id: 'investmentRegion',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.investmentRegion}',
          key: 'investmentRegion',
          options: (fundItems) => produceSelectOptions(fundItems, 'investmentRegion', investmentRegionOrder),
          value: []
        },
        {
          id: 'dividendType',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.dividendType}',
          key: 'dividendType',
          options: (fundItems) => produceSelectOptions(fundItems, 'dividendType', dividendTypeOrder),
          value: []
        },
        {
          id: 'fundRating',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.risk}',
          key: 'fundRating',
          options: (fundItems) => produceSelectOptions(fundItems, 'fundRating', fundRatingOrder),
          value: [],
          tooltip: 'modalTooltip'
        },
        {
          id: 'msRiskRating',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.msRisk}',
          key: 'msRating.ratingName',
          options: (fundItems) => produceSelectOptions(fundItems, 'msRating.ratingName', msRatingOrder),
          value: []
        },
        {
          id: 'baseCurrency',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.currency}',
          key: 'currency.name',
          options: (fundItems) => produceSelectOptions(fundItems, 'currency.name', currencyOrder),
          value: []
        },
        {
          id: 'shareClassType',
          extraClasses: 'large-3',
          type: 'select',
          label: '#{fundList.filter.assetLevel}',
          key: 'shareClassType',
          options: (fundItems) => produceSelectOptions(fundItems, 'shareClassType'),
          value: []
        }
      ]
    }
  ],
  delegation: {
    'fundRangeCode.shortName': {
      lead: {
        key: 'fundRangeCode.longName',
        map: {
          境內: '境內基金',
          境外: '境外基金'
        }
      }
    },
    'fundRangeCode.longName': {
      delegated: {
        key: 'fundRangeCode.shortName',
        map: {
          境內基金: '境內',
          境外基金: '境外'
        }
      }
    }
  },
  labelValuePairs: [
    {
      // without label and value means input element
      key: 'shareClassName.zh||shareClassName.en||isin||taCode',
      apiKey: 'names'
    },
    {
      key: 'fundRangeCode',
      label: 'fundRangeCode',
      value: 'fundRangeCode.value',
      apiKey: 'fundRanges'
    },
    {
      key: 'assetClass.name',
      label: 'assetClass.name',
      value: 'assetClass.assetClassId',
      // It define the relationship used by /xapi/fundList/excel.
      // e.g. '$assetClass' is mapped to 'assetClassList'
      apiKey: 'assetClasses'
    },
    {
      key: 'investmentRegion',
      label: 'investmentRegion',
      value: 'investmentRegion',
      apiKey: 'investmentRegions'
    },
    {
      key: 'dividendType',
      label: 'dividendType',
      value: 'dividendType',
      apiKey: 'dividendTypes'
    },
    {
      key: 'fundRating',
      label: 'fundRating',
      value: 'fundRating',
      apiKey: 'fundRatings'
    },
    {
      key: 'msRating.ratingName',
      label: 'msRating.ratingName',
      value: 'msRiskRating.rating',
      apiKey: 'msRatings'
    },
    {
      key: 'currency.name',
      label: 'currency.name',
      value: 'currency.currencyCode',
      apiKey: 'baseCurrencies'
    },
    {
      key: 'shareClassType',
      label: 'shareClassType',
      value: 'shareClassType',
      apiKey: 'classTypes'
    }
  ]
}

export default filterRules
